import { useState } from "react";
import styled from "@emotion/styled";
import { fromPublic } from "../../utils";

const Container = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const TicketCard = styled.div`
  flex: 1;
  background-color: #0e893c;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  -webkit-mask:
    radial-gradient(circle 18px at 50% 0, transparent 17px, #000 18px)
      0 0 / 100% 51% no-repeat,
    radial-gradient(circle 18px at 50% 100%, transparent 17px, #000 18px)
      0 100% / 100% 51% no-repeat;
  mask:
    radial-gradient(circle 18px at 50% 0, transparent 17px, #000 18px)
      0 0 / 100% 51% no-repeat,
    radial-gradient(circle 18px at 50% 100%, transparent 17px, #000 18px)
      0 100% / 100% 51% no-repeat;
`;

const TicketTop = styled.div`
  padding: 26px 12px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: white;
`;

const TicketMiddle = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 8px;
  gap: 6px;
`;

const CodeText = styled.span`
  font-size: 15px;
  font-weight: 700;
  font-family: RobotoMono, monospace;
  color: #212121;
  user-select: text;
  letter-spacing: 0.5px;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: 0;
`;

const TicketBottom = styled.div`
  padding: 12px 12px 26px;
  text-align: center;
  font-size: 12px;
  color: white;
  line-height: 1.4;
`;

interface DualCouponBoxProps {
  coupons: Array<{
    label: string;
    code: string;
    copyText: string;
  }>;
  copySvg: string;
  copyDoneSvg: string;
}

const DualCouponBox: React.FC<DualCouponBoxProps> = ({ coupons, copySvg, copyDoneSvg }) => {
  const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

  const handleCopy = (code: string, index: number) => {
    navigator.clipboard.writeText(code);
    setCopiedIndex(index);
    setTimeout(() => {
      setCopiedIndex(null);
    }, 5000);
  };

  return (
    <Container>
      {coupons.map((coupon, index) => (
        <TicketCard key={index}>
          <TicketTop>{coupon.label}</TicketTop>
          <TicketMiddle>
            <CodeText>{coupon.code}</CodeText>
            <CopyButton onClick={() => handleCopy(coupon.code, index)}>
              {copiedIndex === index ? (
                <img alt="Copied" src={fromPublic(copyDoneSvg)} width="20" height="20" />
              ) : (
                <img alt="Copy" src={fromPublic(copySvg)} width="20" height="20" />
              )}
            </CopyButton>
          </TicketMiddle>
          <TicketBottom>{coupon.copyText}</TicketBottom>
        </TicketCard>
      ))}
    </Container>
  );
};

export default DualCouponBox;
